import React, { useEffect, useRef, useState } from "react";
import {
  printdebug,
  WrongAnswerAudio,
  RightAnswerAudio,
} from "../Commonimports";

import QuestionsforSutra from "../JsonData/data_1_4_3.json";
import MathInstruction from "../Commoninstruction";
import InstructionStep from "../FirstBox_Instruction_Json/Instruction_1_4_3.json";
import Swal from "sweetalert2";
import Gamesteps from "../Gamesteps";
import { useSelector, useDispatch } from "react-redux";
import { sutraPoints } from "../../Redux/actions";
import Sutrastory from "../Sutrastory";
import sutraStorydata from "../Sutra_Story/story_sutra_1_4_3.json";
import speakText from "../audio tutorial/tutorial_1_4_3.json";
import WatchTutorialModel from "../WatchTutorial";
import { saveUserProgress } from "../dataUtils";
import { useNavigate } from "react-router-dom";
import { getSutraMasterArray } from "../dataUtils";
import { sutraMaster, setQuestion } from "../../Redux/actions";

export default function Sutra_1_4_3() {
  const wronganswer = new Audio(WrongAnswerAudio);
  const Rightanswer = new Audio(RightAnswerAudio);

  const mystate = useSelector((state) => state.soundToggle);
  const mysutraquestion = useSelector((state) => state.questionNumber);
  const attemptsutraPoints = useSelector((state) => state.sutraPoints);
  const uid = useSelector((state) => state.userUid);
  const sutranumber = useSelector((state) => state.sutraMaster);
  const dispatch = useDispatch();

  const [togglespeak, setTogglespeak] = useState(false);
  const inputRef = useRef(null);

  // Defensive: Only use valid question data
  const [nextcounter, setNextcounter] = useState(mysutraquestion);

  // Defensive: fallback to empty string if out of bounds
  const getQuestionValue = (idx, valIdx) =>
    QuestionsforSutra[idx]?.[valIdx] ?? "";

  const [firstNumber, setFirstNumber] = useState(
    getQuestionValue(nextcounter, 0)
  );
  const [secondNumber, setSecondNumber] = useState(
    getQuestionValue(nextcounter, 1)
  );
  const [thirdNumber, setThirdNumber] = useState(
    getQuestionValue(nextcounter, 0) !== ""
      ? Math.ceil(getQuestionValue(nextcounter, 0) / 10) * 10
      : ""
  );

  useEffect(() => {
    if (nextcounter === QuestionsforSutra.length - 1) {
      const NextButton = document.getElementById("BtnNext");
      if (NextButton) {
        NextButton.disabled = true;
      }
    }
  }, [nextcounter]);

  const [message, setMessage] = useState("");
  const [currentStep, setCurrentStep] = useState(1);

  const steps = [
    "Enter value as per Step 1",
    "Enter value as per Step 2",
    "Enter value as per Step 3",
    "Enter value as per Step 4",
  ];

  const [completionTextMessage] = useState(
    "Congratulations! You have successfully understood this Sutra."
  );

  function handleStepInput(userInput, index) {
    const nextButton = document.getElementById("BtnNext");

    function stopAudio(audioElement) {
      if (mystate) {
        audioElement.pause();
        audioElement.currentTime = 0;
      }
    }

    function playAudio(audioElement) {
      if (mystate) {
        audioElement.play();
      }
    }

    // Disable the Next button if user has entered any input
    if (userInput !== "") {
      if (nextButton) {
        nextButton.disabled = true;
      }
    }

    // Sutra-specific logic for expected answers
    const expectedNumbers = [
      0,
      thirdNumber,
      thirdNumber - firstNumber,
      secondNumber - (thirdNumber - firstNumber),
      thirdNumber + (secondNumber - (thirdNumber - firstNumber)),
    ];

    if (isNaN(userInput) || userInput.trim() === "") {
      printdebug(`${isNaN(userInput)} ${userInput.trim() === ""}`);
      printdebug("Please enter a number.");
      setMessage("Please enter your answer. 👇");
      return;
    }

    if (Number(userInput) === expectedNumbers[currentStep]) {
      setTimeout(() => {
        let inputBox = document.getElementById(`inputstep${currentStep}`);
        if (inputBox && currentStep - 1 !== steps.length - 1) {
          inputBox.focus();
        }
      }, 100);

      stopAudio(wronganswer);
      stopAudio(Rightanswer);

      if (currentStep === steps.length) {
        const newPoints = attemptsutraPoints + 5;
        dispatch(sutraPoints(newPoints));

        const progressObject = {
          attemptlevel: "level1",
          attemptchapter: "chapter1",
          attemptsutra: "1_4_3",
          attemptquestion: nextcounter + 1,
          sutrapoints: newPoints,
          timestamp: Date.now(),
        };

        if (uid) {
          saveUserProgress(progressObject).catch((error) => {
            console.error("Failed to persist user progress:", error);
          });
        }
      }

      setCurrentStep(currentStep + 1);
      setMessage("Nice you are right 👍");
      playAudio(Rightanswer);

      setTimeout(() => {
        stopAudio(Rightanswer);
      }, 1500);
    } else {
      stopAudio(Rightanswer);
      stopAudio(wronganswer);

      playAudio(wronganswer);
      setMessage("");

      Swal.fire({
        position: "top",
        icon: "error",
        title: "Wrong Answer",
        text: "Please reread the Sutra of Vedic maths and try again. 😌",
        showConfirmButton: false,
        timer: 2000,
      });

      setTimeout(() => {
        stopAudio(wronganswer);
      }, 2000);
    }
  }

  function handleReset() {
    setCurrentStep(1);
    setMessage("");
    setNextcounter(0);

    const initialFirstNumber = getQuestionValue(0, 0);
    const initialSecondNumber = getQuestionValue(0, 1);
    const initialThirdNumber =
      initialFirstNumber !== "" ? Math.ceil(initialFirstNumber / 10) * 10 : "";

    setFirstNumber(initialFirstNumber);
    setSecondNumber(initialSecondNumber);
    setThirdNumber(initialThirdNumber);

    const nextButton = document.getElementById("BtnNext");
    if (nextButton) {
      nextButton.disabled = false;
    }
  }

  function HandleNextNumber() {
    if (nextcounter < QuestionsforSutra.length - 1) {
      const nextIdx = nextcounter + 1;
      setNextcounter(nextIdx);

      const currentSutra = QuestionsforSutra[nextIdx];
      setFirstNumber(currentSutra?.[0] ?? "");
      setSecondNumber(currentSutra?.[1] ?? "");
      setThirdNumber(
        currentSutra?.[0] !== undefined
          ? Math.ceil(currentSutra[0] / 10) * 10
          : ""
      );
      setCurrentStep(1);
      setMessage("");
    }
    // If at last question, do nothing (Gamesteps will handle congrats/next sutra)
  }

  const finalNumber =
    thirdNumber !== "" && firstNumber !== "" && secondNumber !== ""
      ? thirdNumber + (secondNumber - (thirdNumber - firstNumber))
      : "";

  function handlespeakEnd() {
    setTogglespeak((prevTogglespeak) => !prevTogglespeak);
  }
  const speak = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.onend = handlespeakEnd;
    speechSynthesis.speak(utterance);
  };

  function callspech() {
    const passStoryText = speakText[0]["story"];
    setTogglespeak(!togglespeak);
    speak(passStoryText);
  }

  function stopSpeak() {
    setTogglespeak(!togglespeak);
    if (speechSynthesis) {
      speechSynthesis.cancel();
    }
  }

  useEffect(() => {
    if (speechSynthesis) {
      speechSynthesis.cancel();
      setTogglespeak(false);
    }
  }, []);

  // Navigation logic for next sutra
  const navigate = useNavigate();
  const sutramasterjsonfile = getSutraMasterArray();
  const nextSutraIndex = sutranumber + 1;
  const [nextLevel, nextChapter, nextKey] =
    sutramasterjsonfile[nextSutraIndex] || [];
  const nextSutraRoute =
    nextLevel && nextChapter && nextKey
      ? `/${nextLevel}/${nextChapter}/${nextKey}`
      : null;

  // Defensive render: If the current question is invalid, show congratulations and next button
  if (!QuestionsforSutra[nextcounter]) {
    return (
      <div className="container mt-5">
        <h2>COMPLETING THE WHOLE</h2>
        <div className="alert alert-success">
          Congratulations! You have completed this sutra.
        </div>
        {nextSutraRoute ? (
          <button
            className="btn btn-primary mt-3"
            onClick={() => {
              dispatch(sutraMaster(nextSutraIndex));
              dispatch(setQuestion(0));
              navigate(nextSutraRoute);
            }}
          >
            Next Sutra
          </button>
        ) : (
          <div className="alert alert-info mt-3">
            You have completed all sutras!
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <h2>COMPLETING THE WHOLE</h2>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          margin: "10px 0",
        }}
      >
        <p style={{ margin: 0, padding: 0 }}>1.4 DEFICIENCY FROM TEN</p>{" "}
        <button
          type="button"
          className="btn btn-outline-info btn-sm mx-2"
          data-bs-toggle="modal"
          data-bs-target="#WatchTutorialModal"
        >
          Watch Tutorial
        </button>
      </div>
      {/* load story modal  */}
      <Sutrastory story={sutraStorydata} />
      {/* load video tutorial model  */}
      <WatchTutorialModel
        videoSrc={
          "https://mcusercontent.com/3fc23a5ee812acdf3869a0972/files/25135bc8-8f18-87bc-f764-3b9c61e21e58/sutra1.4.3.mp4"
        }
      />
      <div className="row">
        {/* section for give instruction  */}
        <MathInstruction step={InstructionStep} />

        {/* section for show input box  */}
        <Gamesteps
          currentStep={currentStep}
          steps={steps}
          message={message}
          inputRef={inputRef}
          handleStepInput={handleStepInput}
          HandleNextNumber={HandleNextNumber}
          completionTextMessage={completionTextMessage}
          nextcounter={nextcounter}
          QuestionsforSutra={QuestionsforSutra}
          firstNumber={firstNumber}
          secondNumber={secondNumber}
          handleReset={handleReset}
          finalNumber={finalNumber}
        />
      </div>
    </div>
  );
}
